export const enum StorageKey {
    /**
     * This constant is referenced beyond this project, don't change
     */
    ThemeMode = 'theme_mode',

    ColorScheme = 'colorScheme',
    VoToken = 'voToken',
    PendingMessages = 'pendingMessages',
    DebugLevel = 'widgetDebugLevel',
    GameHintsFinished = 'waitingGameHintsFinished',
    NotificationsEnabled = 'notificationsEnabled',
    SoundNotificationsEnabled = 'soundNotificationsEnabled',
    HideMsgTimeAndStatus = 'minimalisticBubblesEnabled',
    VibrationEnabled = 'vibrationEnabled',
    LastHistoryDumpTimestamp = 'lastHistoryDumpTimestamp',
    GameSettings = 'waitingGameSettings',

    VoiceMessageTranscriptionToggle = 'voiceMessageTranscriptionToggle',

    WidgetContainerOpen = 'widgetContainerOpen',

    ChatMessageVideoConfig = 'chat_widget_chatMessageVideoConfig',

    MediaDownloaded = 'vtb_widget_chat_media_downloaded',

    TimeAlreadyAwaitedForOperatorMs = 'vtb_widget_time_already_awaited_for_operator_in_ms',

    OperatorAwaitTimerCleanupTimestamp = 'vtb_widget_operator_await_timer_cleanup_timestamp',

    ChatOpened = 'vtb_widget_chat_opened',
    InputValue = 'vtb_widget_chat_input_value',
}
